module.exports = __webpack_public_path__ + "static/media/arrow-circle-right.5f4fb1f0.svg";